import mapper from "./mapper"

export const prerequisitesMapper = mapper

export default mapper
